import PropTypes from 'prop-types';
import { TOAST_TYPE } from '@app/constants/commonConstants';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import styles from './ToastMessages.module.scss';

const ToastMessages = ({ type, message, autoClose = true }) => {
  const getIcon = () => {
    if (type === TOAST_TYPE.SUCCESS) {
      return <CatIconSuccess slot="before" />;
    }
    return <CatIconWarningCircle slot="before" />;
  };

  const getVariant = () => {
    if (type === TOAST_TYPE.SUCCESS) {
      return 'success';
    }
    return 'error';
  };

  return (
    <CatToastGroup verticalPosition="top" horizontalPosition="center">
      <CatToast
        variant={getVariant()}
        autoClose={autoClose}
        dismissible
        data-testid="toast"
      >
        {getIcon()}
        <div className={styles['toast-messages__content']}>
          <CatHeading variant="label" data-testid="toast-heading">
            {message}
          </CatHeading>
        </div>
      </CatToast>
    </CatToastGroup>
  );
};

ToastMessages.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  autoClose: PropTypes.bool
};

export default ToastMessages;
